import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GoogleAnalyticalService } from './google-analytics.service';

@Injectable({
  providedIn: 'root'
})

/**
 * tracks user milestones, how far they have gotten in the use of our service.
 */
export class MilestoneService {

  constructor(private gaService: GoogleAnalyticalService) { }

  checkForEvent(eventName: string) {
    const event = localStorage.getItem(eventName);
    if (event) {
      if (eventName === environment.milestones.login) {
        let numSeen = parseInt(event);
        numSeen++;
        if (numSeen === 3) {
          this.gaService.pushTag(environment.milestones.first3Logins);
        } else if (numSeen === 7) {
          this.gaService.pushTag(environment.milestones.first7Logins);
        } else if (numSeen === 15) {
          this.gaService.pushTag(environment.milestones.first15Logins);
        } else if (numSeen === 50) {
          this.gaService.pushTag(environment.milestones.first50Logins);
        } else if (numSeen === 150) {
          this.gaService.pushTag(environment.milestones.first150Logins);
        }
        localStorage.setItem(eventName, numSeen + "");
      }
    }
  }
}
